import { localize } from "lib/i18n/localization";

const Title = localize({
  en_GB: <>Immediate risk assessment</>,
  sv_SE: <></>,
});

export const Trans = { Title };
